<template>
  <div class="Landing">
    <ShortNavbar
      :class="['Navbar', { scrolled: isScrolled }]"
      :SendRequestBusiness="
        () => {
          showRegistrationModal = true;
        }
      "
    />

    <section id="hero" class="hero-section">
      <div class="hero-bg-container">
        <div class="hero-bg-img" />
      </div>
      <div class="container hero-container">
        <div class="hero-content">
          <h1 class="hero-title">
            {{ $t("pages.landing.hero.title") }}
          </h1>
          <p class="hero-subtitle">
            {{ $t("pages.landing.hero.desc") }}
          </p>

          <router-link style="height: 56px" class="btn btn-dark" to="/catalog">
            {{ $t("interface.buttons.choose_course") }}
          </router-link>
        </div>
        <div class="hero-images">
          <!--merged image-->
          <div class="hero-image-wrapper">
            <img
              src="./../assets/img/ReDesign/pages/new_land/banner4.png"
              alt="Portrait of a man"
              class="hero-img-1"
            />
            <img
              src="./../assets/img/ReDesign/pages/new_land/banner1.png"
              alt="Portrait of a woman"
              class="hero-img-2"
            />
            <img
              src="./../assets/img/ReDesign/pages/new_land/banner2.png"
              alt="Portrait of another man"
              class="hero-img-3"
            />
            <!-- <img
              src="./../assets/img/ReDesign/pages/new_land/banner3.png"
              alt="1C Logo"
              class="hero-icon"
            /> -->
          </div>
        </div>
      </div>
    </section>

    <section id="advantages" class="section">
      <div class="container">
        <h2 class="section-title" style="margin-bottom: 80px">
          {{ $t("pages.landing.advantages.title") }}
        </h2>
        <div class="advantages-grid">
          <div class="advantage-card">
            <img
              src="./../assets/img/ReDesign/pages/new_land/adv1.svg"
              alt="Globe icon"
              class="advantage-icon"
            />
            <h3 class="advantage-title">
              {{ $t("pages.landing.advantages.block[0]") }}
            </h3>
          </div>
          <div class="advantage-card">
            <img
              src="./../assets/img/ReDesign/pages/new_land/adv2.svg"
              alt="Check icon"
              class="advantage-icon"
            />
            <h3 class="advantage-title">
              {{ $t("pages.landing.advantages.block[1]") }}
            </h3>
          </div>
          <div class="advantage-card">
            <img
              src="./../assets/img/ReDesign/pages/new_land/adv3.svg"
              alt="Search icon"
              class="advantage-icon"
            />
            <h3 class="advantage-title">
              {{ $t("pages.landing.advantages.block[2]") }}
            </h3>
          </div>
          <div class="advantage-card">
            <img
              src="./../assets/img/ReDesign/pages/new_land/adv4.svg"
              class="advantage-icon"
            />
            <h3 class="advantage-title">
              {{ $t("pages.landing.advantages.block[3]") }}
            </h3>
          </div>
        </div>
      </div>
    </section>

    <section id="courses" class="section">
      <div class="container">
        <div class="courses-header">
          <h2 class="section-title">
            {{ $t("pages.landing.courses.title") }}
          </h2>
        </div>
      </div>

      <div class="container courses-mobile">
        <details
          class="ProfBlock"
          ref="detailRefsC0"
          id="detailRefsC0"
          @click.prevent="onClickC($event, 'detailRefsC0', 0)"
        >
          <summary class="ProfHead noselect">
            <span class="CourseText">{{
              $t("pages.landing.courses.prof_block.beginner.title")
            }}</span>
            <div class="DetailsArrow"></div>
          </summary>

          <article class="course-category">
            <div class="course-content">
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.for_whom") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[0]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[1]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[2]",
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.you_learn") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[0]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[1]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[2]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[3]",
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>

              <router-link
                style="height: 56px"
                class="btn btn-primary btn-auto-top"
                to="/catalog"
              >
                {{ $t("interface.buttons.choose_course") }}
              </router-link>
            </div>
            <div class="course-image-container">
              <div class="IMG IMG1"></div>
              <div class="course-image-overlay">
                <p style="width: 248px">
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[0]",
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[1]",
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[2]",
                    )
                  }}<br />
                  {{
                    $t("pages.landing.courses.prof_block.beginner.help_with[3]")
                  }}
                </p>
              </div>
            </div>
          </article>
        </details>

        <!-- <details
          class="ProfBlock"
          ref="detailRefsC1"
          id="detailRefsC1"
          @click.prevent="onClickC($event, 'detailRefsC1', 1)"
        >
          <summary class="ProfHead noselect">
            <span class="CourseText">{{
              $t("pages.landing.courses.prof_block.advanced.title")
            }}</span>
            <div class="DetailsArrow"></div>
          </summary>

          <article class="course-category">
            <div class="course-content">
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.for_whom") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[0]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[1]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[2]"
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.you_learn") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[0]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[1]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[2]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[3]"
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <router-link class="btn btn-primary btn-auto-top" to="/catalog">
                {{ $t("interface.buttons.choose_course") }}
              </router-link>
            </div>
            <div class="course-image-container">
              <div class="IMG IMG2"></div>
              <div class="course-image-overlay">
                <p style="width: 248px">
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[0]"
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[1]"
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[2]"
                    )
                  }}<br />
                  {{
                    $t("pages.landing.courses.prof_block.advanced.help_with[3]")
                  }}
                </p>
              </div>
            </div>
          </article>
        </details> -->
      </div>

      <div class="courses-slider">
        <div class="container cours-cont">
          <div class="cbtns">
            <span
              :class="{
                cbtn: true,
                active: courseOpened === 'start',
              }"
              @click="courseOpened = 'start'"
              >{{ $t("pages.landing.courses.prof_block.beginner.title") }}</span
            >
            <!-- <span
              :class="{
                cbtn: true,
                active: courseOpened === 'pro',
              }"
              @click="courseOpened = 'pro'"
              >{{ $t("pages.landing.courses.prof_block.advanced.title") }}</span
            > -->
          </div>

          <article class="course-category" v-if="courseOpened === 'start'">
            <div class="course-content">
              <h3 class="course-title">
                {{ $t("pages.landing.courses.prof_block.beginner.title") }}
              </h3>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.for_whom") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[0]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[1]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.for_whom[2]",
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.you_learn") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[0]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[1]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[2]",
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.beginner.you_learn[3]",
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <router-link
                style="height: 56px"
                class="btn btn-primary btn-auto-top"
                to="/catalog"
              >
                {{ $t("interface.buttons.choose_course") }}
              </router-link>
            </div>
            <div class="course-image-container">
              <div class="IMG IMG1"></div>
              <div class="course-image-overlay">
                <p style="width: 248px">
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[0]",
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[1]",
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.beginner.help_with[2]",
                    )
                  }}<br />
                  {{
                    $t("pages.landing.courses.prof_block.beginner.help_with[3]")
                  }}
                </p>
              </div>
            </div>
          </article>

          <!-- <article class="course-category" v-if="courseOpened === 'pro'">
            <div class="course-content">
              <h3 class="course-title">
                {{ $t("pages.landing.courses.prof_block.advanced.title") }}
              </h3>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.for_whom") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[0]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[1]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.for_whom[2]"
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <div class="course-details">
                <h4>{{ $t("pages.landing.courses.prof_block.you_learn") }}</h4>
                <ul>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[0]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[1]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[2]"
                        )
                      }};
                    </p>
                  </li>
                  <li>
                    <p>
                      {{
                        $t(
                          "pages.landing.courses.prof_block.advanced.you_learn[3]"
                        )
                      }}.
                    </p>
                  </li>
                </ul>
              </div>
              <router-link class="btn btn-primary btn-auto-top" to="/catalog">
                {{ $t("interface.buttons.choose_course") }}
              </router-link>
            </div>
            <div class="course-image-container">
              <div class="IMG IMG2"></div>
              <div class="course-image-overlay">
                <p style="width: 248px">
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[0]"
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[1]"
                    )
                  }}<br />
                  {{
                    $t(
                      "pages.landing.courses.prof_block.advanced.help_with[2]"
                    )
                  }}<br />
                  {{
                    $t("pages.landing.courses.prof_block.advanced.help_with[3]")
                  }}
                </p>
              </div>
            </div>
          </article> -->
        </div>
      </div>
    </section>

    <section id="jobs" class="section">
      <div class="jobs-bg-container">
        <div class="container jobs-container">
          <div class="jobs-content">
            <h2 class="section-title">
              {{ $t("pages.landing.jobs.title") }}
            </h2>
            <p class="jobs-subtitle">{{ $t("pages.landing.jobs.desc") }}</p>
          </div>
          <div class="job-cards-wrapper">
            <div class="job-card card-1">
              <h4>{{ $t("pages.landing.jobs.block[0].title") }}</h4>
              <p>{{ $t("pages.landing.jobs.block[0].desc") }}</p>

              <router-link
                class="btn btn-primary btn-bottom"
                to="/catalog"
                style="height: 56px"
                >{{ $t("pages.landing.jobs.block[0].btn") }}</router-link
              >
            </div>
            <div class="job-card card-2">
              <h4>{{ $t("pages.landing.jobs.block[1].title") }}</h4>
              <p>{{ $t("pages.landing.jobs.block[1].desc") }}</p>
              <span
                style="height: 56px"
                class="btn btn-primary off btn-bottom"
                >{{ $t("pages.landing.jobs.block[1].btn") }}</span
              >
            </div>
            <div class="job-card card-3">
              <h4>{{ $t("pages.landing.jobs.block[2].title") }}</h4>
              <p>{{ $t("pages.landing.jobs.block[2].desc") }}</p>
              <span
                style="height: 56px"
                class="btn btn-primary off btn-bottom"
                >{{ $t("pages.landing.jobs.block[2].btn") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="partners" class="section">
      <div class="container">
        <h2 class="section-title" style="margin-bottom: 40px">
          {{ $t("pages.landing.partners.title") }}
        </h2>
      </div>

      <div class="PListWrapper" ref="wrapper">
        <div class="PList" ref="list">
          <img
            v-for="(logo, index) in duplicatedLogos"
            :key="index"
            :src="logo"
            alt=""
          />
        </div>
      </div>
    </section>

    <section id="why-1c" class="section">
      <div class="container">
        <h2 class="section-title" style="margin-bottom: 40px">
          {{ $t("pages.landing.why-1c.title") }}
        </h2>
        <div class="why-1c-grid">
          <div class="why-1c-item">
            <img
              src="./../assets/img/ReDesign/pages/new_land/banner6.png"
              alt="Business meeting"
              class="why-1c-img"
            />
            <h3 class="why-1c-title">
              {{ $t("pages.landing.why-1c.block[0].title") }}
            </h3>
            <p class="why-1c-text">
              {{ $t("pages.landing.why-1c.block[0].desc") }}
            </p>
          </div>
          <div class="why-1c-item">
            <img
              src="./../assets/img/ReDesign/pages/new_land/banner7.png"
              alt="People in a factory"
              class="why-1c-img"
            />
            <h3 class="why-1c-title">
              {{ $t("pages.landing.why-1c.block[1].title") }}
            </h3>
            <p class="why-1c-text">
              {{ $t("pages.landing.why-1c.block[1].desc") }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section id="how-it-works" class="section">
      <div class="container how-it-works-container">
        <div class="how-it-works-content">
          <h2 class="section-title">
            {{ $t("pages.landing.how-it-works.title") }}
          </h2>
          <div class="steps">
            <div class="step">
              <div class="step-icon">
                <img
                  src="./../assets/img/ReDesign/pages/new_land/card_banner5.svg"
                  alt=""
                />
                <span>01</span>
              </div>
              <div class="step-text">
                <h4>{{ $t("pages.landing.how-it-works.block[0]") }}</h4>
                <router-link
                  style="height: 48px"
                  class="btn btn-primary btn-small"
                  to="/catalog"
                >
                  {{ $t("interface.buttons.choose_course") }}
                </router-link>
              </div>
            </div>

            <div class="step">
              <div class="step-icon">
                <img
                  src="./../assets/img/ReDesign/pages/new_land/card_banner5.svg"
                  alt=""
                />
                <span>02</span>
              </div>
              <div class="step-text">
                <h4>{{ $t("pages.landing.how-it-works.block[1]") }}</h4>
              </div>
            </div>

            <div class="step">
              <div class="step-icon">
                <img
                  src="./../assets/img/ReDesign/pages/new_land/card_banner5.svg"
                  alt=""
                />
                <span>03</span>
              </div>
              <div class="step-text">
                <h4>
                  {{ $t("pages.landing.how-it-works.block[2]") }}
                </h4>
              </div>
            </div>
          </div>
          <p class="how-it-works-note">
            {{ $t("pages.landing.how-it-works.note") }}
            <a
              href="#"
              @click.prevent="
                () => {
                  requestModalShow = 1;
                  disableScroll();
                }
              "
              >{{ $t("pages.landing.how-it-works.note-link") }}</a
            >
          </p>
        </div>
        <div class="how-it-works-image">
          <img
            src="./../assets/img/ReDesign/pages/new_land/request_sended.png"
            alt="Illustration of application process"
          />
        </div>
      </div>
    </section>

    <section id="faq" class="section">
      <div class="container">
        <h2 class="section-title" style="margin-bottom: 40px">
          {{ $t("pages.faq.title") }}
        </h2>
        <div class="ProfList">
          <details
            class="ProfBlock"
            v-for="(part, index) in FAQ"
            :key="`Part-${index}-${part.title}`"
            :id="`ProfBlock${index}`"
            ref="detailRefs"
            @click.prevent="onClick($event, index)"
          >
            <summary class="ProfHead noselect">
              <span class="ProfText">{{ $t(part.title) }}</span>
              <div class="DetailsArrow"></div>
            </summary>

            <div class="ProfBody">
              <span class="ProfDesc" v-html="$t(part.desc)"></span>
            </div>
          </details>
        </div>
      </div>
    </section>

    <section id="cta" class="section">
      <div class="container cta-container">
        <h2 class="section-title">
          {{ $t("pages.landing.cta.title") }}
        </h2>
        <router-link style="height: 56px" class="btn btn-primary" to="/catalog">
          {{ $t("interface.buttons.choose_course") }}
        </router-link>
        <p class="cta-note">{{ $t("pages.landing.cta.desc") }}</p>
      </div>
    </section>

    <GeneralFooter />

    <DefaultModal
      :key="rMKey"
      v-if="requestModalShow === 1"
      class="DefaultModal"
      :rmtitle="$t(requestModal[0].title)"
      :rmdesc="$t(requestModal[0].desc)"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <DefaultInput
          v-model="rMfio"
          @update:modelStatus="rMfioValidate = $event"
          :placeholder="$t('components.default_modal[2].name_surname')"
          :isNull="false"
          type="fio"
        />
        <DefaultInput
          v-model="rMphone"
          @update:modelPhoneFormat="phoneFormat = $event"
          @update:modelStatus="rMphoneValidate = $event"
          :label="$t('components.default_modal[2].phone')"
          type="phone"
          :isNull="false"
        />
        <DefaultTextarea
          v-model="rmComment"
          @update:modelStatus="rmCommentValidate = $event"
          :placeholder="$t('components.default_modal[2].comment')"
        />
      </template>
      <template v-slot:ButtonsSection>
        <div class="data-policy">
          <CustomSelect
            v-model="dataPolicy"
            :options="dataPolicyOpt"
            style="width: fit-content"
            type="multiselect"
            typeSelect="checkboxList"
          />
          <span class="text">
            {{ $t("components.default_modal[2].condition_agreement_1") }}
            <a class="link" :href="$t('links.data_policy')" download>{{
              $t("components.default_modal[2].condition_agreement_2")
            }}</a>
          </span>
        </div>

        <button
          style="height: 48px; font-size: 16px"
          :class="{
            'btn-n-yellow': validateRequestSucces,
            'btn-n-yellow-disabled': !validateRequestSucces,
          }"
          @click.native="sendRequest"
        >
          {{ $t("components.default_modal[2].button") }}
        </button>
      </template>
    </DefaultModal>

    <DefaultModal
      v-if="requestModalShow === 2"
      class="DefaultModal"
      :rmtitle="$t(requestModal[1].title)"
      :rmdesc="$t(requestModal[1].desc)"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:ButtonsSection>
        <button
          class="btn-n-yellow"
          style="height: 48px; font-size: 16px"
          @click.native="handleCloseModal"
        >
          {{ $t("components.default_modal[1].button") }}
        </button>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import ShortNavbar from "@/components/ShortNavbar";
import GeneralFooter from "@/components/Footer";
import DefaultModal from "@/components/DefaultModal";
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";

import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import { Pagination, Navigation } from "swiper/modules";
import { gsap } from "gsap";
import { ElNotification } from "element-plus";
import { RequestCreate } from "@/api/request.js";

// Import Swiper styles
import "swiper/swiper.css";
import "swiper/modules/pagination.css";
import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultModal,
    GeneralFooter,
    ShortNavbar,
    Swiper,
    SwiperSlide,
    DefaultInput,
    DefaultTextarea,
    CustomSelect,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
  data() {
    return {
      isAtStart: true,
      isAtEnd: false,

      // Данные для модалки
      scrollPosition: 0,
      requestModalShow: null,
      phone_format: "+7",
      phoneFormat: null,
      rMKey: 0,
      rMfio: "",
      rMfioValidate: false,
      rMphone: "",
      rMphoneValidate: false,
      rmComment: "",
      rmCommentValidate: false,
      requestModal: [
        {
          title: "components.default_modal[2].title",
          desc: "components.default_modal[2].desc",
        },
        {
          title: "components.default_modal[1].title",
          desc: "components.default_modal[1].desc",
        },
      ],
      available_phones: [
        {
          type: "+7",
          text: "Российская Федерация",
          format: "XXX XXX XX XX",
          length: 13,
        },
        {
          type: "+998",
          text: "Узбекистан",
          format: "XX XXX XX XX",
          length: 12,
        },
      ],
      dataPolicy: [],
      dataPolicyOpt: [
        {
          value: "dataPolicy",
          name: "",
        },
      ],

      FAQ: [
        {
          title: "pages.faq.list[0].title",
          desc: "pages.faq.list[0].desc",
        },
        {
          title: "pages.faq.list[1].title",
          desc: "pages.faq.list[1].desc",
        },
        {
          title: "pages.faq.list[2].title",
          desc: "pages.faq.list[2].desc",
        },
        {
          title: "pages.faq.list[3].title",
          desc: "pages.faq.list[3].desc",
        },
        {
          title: "pages.faq.list[4].title",
          desc: "pages.faq.list[4].desc",
        },
      ],

      logos: [
        // {
        //   width: 245,
        //   url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo1.png"),
        // },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo2.png"),
        },
        // {
        //   width: 80,
        //   url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo3.png"),
        // },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo4.png"),
        },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo5.png"),
        },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo6.png"),
        },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo7.png"),
        },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo8.png"),
        },
        {
          width: 80,
          url: require("./../assets/img/ReDesign/pages/new_land/Partners/logo9.png"),
        },
      ],
      duplicatedLogos: [],

      courseOpened: "start",

      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    const wrapperEl = this.$refs.wrapper;
    const listEl = this.$refs.list;

    let logosOrigWidth = this.logos.map((x) => x.width);
    let logosOrigWidthSumm = logosOrigWidth.reduce(
      (acc, number) => acc + number,
      0,
    );
    logosOrigWidthSumm += (this.logos.length - 1) * 56;
    let dublicatesCount = Math.ceil(wrapperEl.offsetWidth / logosOrigWidthSumm);

    let logosURL = this.logos.map((x) => x.url);
    let dublicates = [];
    for (let i = 0; i < dublicatesCount * 2; i++) {
      dublicates.push([logosURL]);
    }

    let logosWithGAP =
      logosOrigWidth.reduce((acc, number) => acc + number, 0) +
      this.logos.length * 56;

    this.duplicatedLogos = dublicates.flat().flat();

    gsap.to(listEl, {
      x: -logosWithGAP,
      duration: 24,
      ease: "linear",
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % logosWithGAP),
      },
    });
  },
  computed: {
    validateRequestSucces() {
      return (
        this.rMfioValidate &&
        this.rMphoneValidate &&
        this.rmCommentValidate &&
        this.dataPolicy.length > 0
      );
    },
    rMphone_number() {
      return `${this.phone_format}${this.rMphone}`;
    },
    requestModalValidator() {
      let res = {
        fio: false,
        fioStatus: "Поле не заполнено",
        phone: false,
        phoneStatus: "Поле не заполнено",
      };

      // Проверка ФИО (должно содержать хотя бы 2 слова, например: Имя Фамилия)
      if (this.rMfio.trim().length > 0) {
        const fioWords = this.rMfio.trim().split(/\s+/);
        if (fioWords.length >= 2) {
          res.fio = true;
          res.fioStatus = "OK";
        } else {
          res.fioStatus = "Введите имя и фамилию";
        }
      }

      // Проверка узбекского номера телефона
      if (this.rMphone_number.trim().length > 0) {
        const cleanedPhone = this.rMphone_number.replace(/[^\d]/g, ""); // Удаляем всё кроме цифр

        const uzbekRegex = /^(998)?\d{9}$/; // Узбекистан: 998XXXXXXXXX или 9XXXXXXXX
        const russianRegex = /^(7|8)\d{10}$/; // строго 7 или 8 и ещё 10 цифр

        if (this.phone_format === "+998" && uzbekRegex.test(cleanedPhone)) {
          res.phone = true;
          res.phoneStatus = "OK (Узбекистан)";
        } else if (
          this.phone_format === "+7" &&
          russianRegex.test(cleanedPhone)
        ) {
          res.phone = true;
          res.phoneStatus = "OK (Россия)";
        } else {
          res.phoneStatus = "Некорректный номер телефона";
        }
      }

      return res;
    },
  },
  methods: {
    async sendRequest() {
      let full_number = this.phoneFormat + this.rMphone.replace(/\D/g, "");

      try {
        let reqResponse = await RequestCreate({
          surname_name: this.rMfio,
          phone: full_number,
          email: "",
          additional: this.rmComment,
          type_code: "ec_catalog_request",
          data_policy: this.dataPolicy.length > 0 ? true : false,
        });

        if (reqResponse.status != 200) {
          throw new Error("Ошибка");
        }

        this.requestModalShow = 2;
      } catch (e) {
        ElNotification({
          title: "Упс!",
          message: "Извините, произошла ошибка на сервере",
          type: "error",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      }

      this.requestModalShow = 2;
    },
    handleCloseModal() {
      this.requestModalShow = null;
      this.enableScroll();
      this.rMKey++;
      this.rMfio = "";
      this.rMphone = "";
      this.rmComment = "";
      this.dataPolicy = [];
    },
    phoneMask(event) {
      let input = event.target;
      let value = input.value.replace(/\D/g, ""); // Удаляем все нецифровые символы
      let formattedValue = "";

      if (this.phone_format === "+998") {
        // Узбекистан: XX XXX XX XX (9 цифр)
        value = value.substring(0, 9); // максимум 9 цифр
        if (value.length >= 1) formattedValue += value.substring(0, 2);
        if (value.length >= 3) formattedValue += " " + value.substring(2, 5);
        if (value.length >= 6) formattedValue += " " + value.substring(5, 7);
        if (value.length >= 8) formattedValue += " " + value.substring(7, 9);
      } else if (this.phone_format === "+7") {
        // Россия: XXX XXX XX XX (10 цифр)
        value = value.substring(0, 10); // максимум 10 цифр
        if (value.length >= 1) formattedValue += value.substring(0, 3);
        if (value.length >= 4) formattedValue += " " + value.substring(3, 6);
        if (value.length >= 7) formattedValue += " " + value.substring(6, 8);
        if (value.length >= 9) formattedValue += " " + value.substring(8, 10);
      } else {
        // Без формата — просто ограничим до 10 цифр
        value = value.substring(0, 10);
        formattedValue = value;
      }

      input.value = formattedValue;
      this.rMphone = formattedValue;
    },
    disableScroll() {
      // Запоминаем позицию скролла
      this.scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Рассчитываем ширину скроллбара
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Блокируем скролл
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.style.height = "100%";

      // Компенсируем ширину скроллбара
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // Для iOS Safari
      document.body.style.overscrollBehavior = "none";
    },
    enableScroll() {
      // Восстанавливаем скролл
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.height = "";
      document.body.style.paddingRight = "";

      // Возвращаем позицию скролла
      window.scrollTo(0, this.scrollPosition);

      // Для iOS
      document.body.style.overscrollBehavior = "";
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 800;
    },

    onReachEnd() {
      this.isAtEnd = true;
    },
    onReachBeginning() {
      this.isAtStart = true;
    },
    onFromEdge() {
      this.isAtStart = false;
      this.isAtEnd = false;
    },

    onClick(event, index) {
      const detailEl = this.$refs.detailRefs[index];
      const bodyEl = detailEl.querySelector(".ProfBody");

      this.scrollTo(`ProfBlock${index}`);

      if (!detailEl.open) {
        // Открытие
        detailEl.open = true;
        this.animateOpen(bodyEl);
      } else {
        // Закрытие
        this.animateClose(bodyEl, () => {
          detailEl.open = false;
        });
      }
    },
    onClickC(event, refName, index) {
      const detailEl = this.$refs[refName];
      const bodyEl = detailEl.querySelector(".course-category");

      this.scrollTo(`detailRefsC${index}`);

      if (!detailEl.open) {
        // Открытие
        detailEl.open = true;
        this.animateOpen(bodyEl);
      } else {
        // Закрытие
        this.animateClose(bodyEl, () => {
          detailEl.open = false;
        });
      }
    },
    animateOpen(el) {
      el.style.display = "block";

      gsap.fromTo(
        el,
        { height: 0, opacity: 0, y: -10 },
        {
          height: el.scrollHeight,
          opacity: 1,
          y: 0,
          duration: 0.4,
          ease: "power2.out",
          onComplete: () => {
            el.style.height = "auto";
          },
        },
      );
    },
    animateClose(el, onComplete) {
      gsap.to(el, {
        height: 0,
        opacity: 0,
        y: -10,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          el.style.display = "none";
          if (onComplete) onComplete();
        },
      });
    },
    scrollTo(elId) {
      const el = document.querySelector(`#${elId}`);
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const topOffset = rect.top; // положение относительно viewport
      const threshold = window.innerHeight * 0.8;

      // Если верх элемента ниже 80% экрана — прокрутить
      if (topOffset > threshold) {
        const scrollY = window.scrollY + topOffset - 20;
        window.scrollTo({
          top: scrollY,
          behavior: "smooth",
        });
      }
    },

    imgURL(url) {
      return `
        background: url("${url}");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      `;
    },
  },
};
</script>

<style scoped>
.btn.btn-primary.off {
  cursor: default;
}

.Navbar.scrolled {
  background-color: #fff; /* изменённый цвет */
}

.cbtns {
  position: relative;
  display: flex;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}
.cbtn {
  position: relative;
  display: block;

  padding: 12px 8px;

  cursor: pointer;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;

  color: #1a1a1a;

  border-radius: 8px;
  background-color: #f8f8f8;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  transition: 0.3s;
}
.cbtn:hover {
  opacity: 0.9;
}
.cbtn.active {
  background-color: #1a1a1a;
  color: #ffffff;
}

.cours-cont {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 43px;
  gap: 24px;
}

.Navbar {
  position: fixed;
  padding: 15px 0%;
  top: 0;

  background-color: #f9d773;
}

.courses-mobile {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.PListWrapper {
  overflow: hidden;
  width: 100%;
}
.PList {
  display: flex;
  gap: 56px;
  will-change: transform;
  width: fit-content;
}
.PList img {
  height: 80px;
  flex-shrink: 0;
}

.PTop,
.PBot {
  position: relative;
  display: flex;

  margin: 0% auto;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
}
.ImgContainer {
  position: relative;
  display: block;

  width: 160px;
  height: 60px;
}

.course-content .btn.btn-auto-top {
  margin-top: auto;
  width: fit-content;
}

.IMG {
  position: relative;
  display: block;

  width: 100%;
  height: 100%;
}

.IMG1 {
  background: url("./../assets/img/ReDesign/pages/new_land/slider1.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.IMG2 {
  background: url("./../assets/img/ReDesign/pages/new_land/slider2.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.btn-bottom {
  margin-top: auto;
  width: 100%;
}

.Landing {
  width: 100%;

  overflow: hidden;
  background: white;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: inherit;
}

.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.section {
  padding-top: 60px;
  padding-bottom: 60px;
}

.section-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0;
  font-family: "Involve";
}

.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5;
  cursor: pointer;
  transition: opacity 0.3s ease;
  border: none;
  font-family: "Involve";
  text-align: center;
  height: 59px;
}

.btn:hover {
  opacity: 0.9;
}

.btn-dark {
  background-color: #1a1a1a;
  color: #ffffff;
}

.btn-primary {
  background-color: #f9d773;
  color: #1a1a1a;
}

.site-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: 26px 0;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-images {
  display: flex;
  align-items: center;
  gap: 4px;
}

.logo-images img:first-child {
  width: 66px;
  height: 66px;
}

.logo-images img:last-child {
  width: 140px;
  height: 33px;
}

.main-nav {
  display: flex;
  gap: 24px;
  font-size: 16px;
  font-weight: 500;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.lang-switcher {
  display: flex;
  background-color: #fadf8f;
  border-radius: 8px;
  opacity: 0.9;
}

.lang-btn {
  padding: 10px;
  border: none;
  background-color: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  width: 40px;
  height: 40px;
}

.lang-btn.active {
  background-color: #f9d773;
}

.btn-small {
  padding: 12px 20px;
  font-size: 16px;
}

.mobile-nav-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
}

.hero-section {
  background-color: #f9d773;
  padding-top: 120px; /* Header height */
  min-height: 800px;
  display: flex;
  position: relative;
  overflow: hidden;
}

.hero-bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.hero-bg-img {
  position: relative;
  display: block;

  margin-left: auto;

  width: auto;
  height: 100%;

  aspect-ratio: 1 / 0.4166;

  background: url("./../assets/img/ReDesign/pages/new_land/Фон.png");
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;

  filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(10%)
    hue-rotate(58deg) brightness(104%) contrast(104%);
}

.hero-container {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 465px;
  gap: 40px;
  height: fit-content;
}

.hero-content {
  max-width: 611px;
  margin-top: auto;
  height: fit-content;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 24px;
  font-family: "Involve";
  word-break: break-word;
}

.hero-subtitle {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  color: #666666;
  margin: 0 0 56px;
  font-family: "Involve";
}

.hero-images {
  position: relative;
  height: 464px;
  width: 465px;
}

.hero-image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image-wrapper > * {
  position: absolute;
  border-radius: 16px;
}

.hero-img-1 {
  /* 3:1264 */
  width: 252px;
  height: 252px;
  top: 210px;
  left: 210px;
  object-fit: cover;
}

.hero-img-2 {
  /* 3:1267 */
  width: 252px;
  height: 252px;
  top: 0;
  left: 0;
  object-fit: cover;
}

.hero-img-3 {
  /* 3:1274 */
  width: 188px;
  height: 188px;
  top: 0;
  left: 277px;
  object-fit: cover;
}

.hero-icon {
  /* 3:1271 */
  width: 188px;
  height: 188px;
  top: 276px;
  left: 0;
}

.hero-icon-bg {
  width: 100%;
  height: 100%;
}

.hero-icon-logo {
  position: absolute;
  width: 149px;
  height: 83px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#advantages {
  background-color: #ffffff;
  margin-top: 60px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.advantage-card {
  background-color: #f8f8f8;
  border-radius: 24px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.advantage-icon {
  width: 80px;
  height: 80px;
}

.advantage-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  font-family: "Involve";
  color: #1a1a1a;
  word-break: break-word;
}

#courses {
  background-color: #ffffff;
}

.courses-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.courses-nav {
  margin-top: 40px;

  width: calc((100% - 24px) / 2);
  margin-left: calc(((100% - 24px) / 2) / 2);

  display: flex;
  gap: 16px;

  justify-content: flex-end;
}

.course-nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9d773;
}

.isDisabled {
  background-color: #f8f8f8;
}

.courses-slider {
  /* In a real implementation, this would be a slider container */
  overflow: hidden;
}

.course-category {
  position: relative;
  background-color: #f8f8f8;
  border-radius: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  height: 720px;
  margin: 0% auto;
  gap: 24px;
  width: 100%;
}

.course-content {
  position: relative;
  display: flex;
  flex-direction: column;

  margin: auto;

  padding: 40px;
  width: 555px;
  height: fit-content;

  flex-grow: 1;
  flex-shrink: 0;

  overflow-y: auto;
}

.course-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 40px;
  font-family: "Involve";
  word-break: break-word;
}

.course-details {
  margin-bottom: 16px;
}

.course-details ul {
  margin: 0;
  padding-left: 28px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  color: #666666;
}

.course-details h4 {
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 8px;
  font-family: "Involve";
}

.course-details p {
  font-size: 18px;
  font-weight: 500;
  color: #666666;
  line-height: 1.5;
  margin: 0;
  font-family: "Involve";
}

.course-content .btn {
  margin-top: 32px;
}

.course-image-container {
  position: relative;
  width: 450px;
  height: 100%;
}

.course-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.course-image-overlay {
  position: absolute;
  bottom: 24px;
  left: 50%;
  border-radius: 16px;
  padding: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;

  transform: translateX(-50%);

  aspect-ratio: 1 / 0.4652;

  background: url("./../assets/img/ReDesign/pages/new_land/card_banner4.png");
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;

  word-break: break-word;
}

.course-image-overlay p {
  margin: 0;
  font-family: "Involve";
}

.jobs-bg-container > .jobs-container {
  padding-left: 40px;
  padding-right: 40px;
}
.jobs-bg-container {
  background-image: url("./../assets/img/ReDesign/pages/new_land/banner5.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 24px;
  padding: 40px 0;
  margin: 0 auto;
  max-width: 1128px;
}

.jobs-container {
  position: relative;
}

.jobs-content {
  max-width: 690px;
  margin-bottom: 40px;
}

.jobs-content .section-title {
  color: #ffffff;
}

.jobs-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 24px;
  font-weight: 500;
  margin-top: 16px;
  font-family: "Involve";
}

.job-cards-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 24px;
  justify-content: flex-start;
  word-break: break-word;
}

.job-card {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.job-card h4 {
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  font-family: "Involve";
}

.job-card p {
  font-size: 24px;
  font-weight: 500;
  color: #666666;
  margin: 0;
  font-family: "Involve";
}

.card-1 {
  width: 264px;
  height: 212px;
  background-image: url("./../assets/img/ReDesign/pages/new_land/card_banner1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding-top: 40px;
}

.card-2 {
  width: 264px;
  height: 268px;
  background-image: url("./../assets/img/ReDesign/pages/new_land/card_banner2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding-top: 40px;
}

.card-3 {
  width: 264px;
  height: 324px;
  background-image: url("./../assets/img/ReDesign/pages/new_land/card_banner3.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding-top: 40px;
}

.how-it-works-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}
.how-it-works-content {
  width: 665px;
  max-width: 100%;
}

.how-it-works-content .section-title {
  margin-bottom: 40px;
}

.steps {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 40px;
}

.step > * {
  margin: auto 0%;
}
.step {
  display: flex;
  align-items: center;
  gap: 16px;
}
.step:nth-child(1),
.step:nth-child(2) {
  width: calc((100% - 24px) / 2);
  flex-shrink: 0;
}
.step-icon {
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.step-icon img {
  width: 100%;
  height: 100%;
}

.step-icon span {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 36px;
  font-weight: 600;
  font-family: "Involve";
}

.step-text h4 {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 0px;
  color: #666666;
  font-family: "Involve";

  line-height: 130%;
}

.step-text .btn-small {
  margin-top: 8px;
  padding: 12px 20px;
  font-size: 16px;
}

.how-it-works-note {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.3;
  font-family: "Involve";
}

.how-it-works-note a {
  color: #fd6161;
  text-decoration: underline;
}

.how-it-works-image img {
  width: 100%;
  max-width: 548px;
  border-radius: 24px;
}

#partners {
  background-color: #ffffff;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 56px;
  align-items: center;
}

.partners-grid img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.6;
  transition: all 0.3s ease;
}

.partners-grid img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

.why-1c-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.why-1c-item {
  display: flex;
  flex-direction: column;
}

.why-1c-img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  margin-bottom: 24px;
}

.why-1c-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 16px;
  font-family: "Involve";
}

.why-1c-text {
  font-size: 18px;
  line-height: 1.5;
  color: rgba(35, 35, 35, 0.7);
  margin: 0;
  font-family: "Involve";
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.faq-item {
  background-color: #f8f8f8;
  border-radius: 16px;
  padding: 24px;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  list-style: none;
  font-family: "Involve";
}

.faq-question::-webkit-details-marker {
  display: none;
}

.faq-arrow {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.faq-item[open] > summary .faq-arrow {
  transform: rotate(180deg);
}

.faq-answer {
  padding-top: 24px;
  font-size: 18px;
  line-height: 1.5;
  color: #666666;
}

.faq-answer p {
  margin: 0 0 1em 0;
  font-family: "Involve";
}

.faq-answer p:last-child {
  margin-bottom: 0;
}

#cta {
  margin-bottom: 60px;
}

.cta-container {
  text-align: center;
  max-width: 744px;
}

.cta-container .section-title {
  margin-bottom: 40px;
}

.cta-note {
  margin-top: 16px;
  font-size: 14px;
  color: #666666;
  font-family: "Involve";
}

.site-footer {
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 60px 0;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 60px;
  border-bottom: 1px solid #666666;
  margin-bottom: 40px;
}

.footer-logo-and-socials {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer-socials {
  display: flex;
  gap: 16px;
}

.footer-socials a {
  opacity: 0.8;
  transition: opacity 0.3s;
}

.footer-socials a:hover {
  opacity: 1;
}

.footer-contacts {
  display: flex;
  gap: 40px;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-phone {
  font-size: 24px;
  font-weight: 600;
}

.contact-desc,
.contact-address,
.contact-email {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  opacity: 0.65;
  font-style: normal;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  max-width: 70%;
}

.footer-links a {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  opacity: 0.65;
  transition: opacity 0.3s;
}

.footer-links a:hover {
  opacity: 1;
}

.footer-copyright {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.65;
  margin: 0;
}

.ProfList {
  position: relative;
  display: flex;

  margin: 0% auto;

  min-width: 0%;
  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}
.ProfHead > * {
  margin-top: auto;
  margin-bottom: auto;
}
.DetailsArrow {
  position: relative;
  display: block;

  width: 40px;
  height: 40px;

  background: url("../assets/img/ReDesign/pages/landing/details_arrow.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;

  background-color: white;
  border-radius: 8px;

  transition: 0.2s;
}
.ProfBlock[open] .DetailsArrow {
  rotate: 180deg;
}

.ProfBlock {
  position: relative;
  display: block;

  min-width: 0px;
  width: 100%;

  height: fit-content;

  background-color: #f8f8f8;
  border-radius: 8px;
}
.ProfHead {
  position: relative;
  display: flex;

  cursor: pointer;

  padding: 24px;

  width: 100%;
  height: fit-content;

  list-style: none;

  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}
.ProfText {
  position: relative;
  display: block;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0px;

  color: #1a1a1a;
}
.CourseText {
  position: relative;
  display: block;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.ProfBody {
  position: relative;
  display: block;

  padding: 24px 24px;
  padding-top: 0px;

  width: 100%;
  height: fit-content;

  overflow: hidden;
}
.ProfDesc {
  position: relative;
  display: block;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.5px;

  color: #666666;
}
.DefaultModal p {
  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  color: #666666;
  position: relative;
  display: inline;
  width: fit-content;
  height: fit-content;
  max-width: 100%;
}
.DefaultModal .BackText {
  display: inline;
  position: relative;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal;
  word-wrap: break-word;
}
.data-policy {
  display: flex;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.data-policy > .text {
  display: inline-block;
  position: relative;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;

  color: #666666;
}
.data-policy > .text > .link {
  display: inline;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal;
  word-wrap: break-word;
}
</style>

<style scoped>
@media (max-width: 992px) {
  .jobs-bg-container > .jobs-container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .hero-bg-container {
    height: calc(100% - 56px);
  }

  .hero-img-1 {
    width: calc((100% - 20px) / 2);
    height: auto;
    aspect-ratio: 1 / 1;
    top: calc(50% + 10px);
    left: calc(100% / 2 + 10px);
  }
  .hero-img-2 {
    width: calc((100% - 20px) / 2);
    height: auto;
    aspect-ratio: 1 / 1;
  }
  .hero-img-3 {
    height: auto;
    aspect-ratio: 1 / 1;
    left: calc(100% / 2 + 10px);
    width: calc((100% - 20px) / 2);
  }
  .hero-icon {
    width: calc((100% - 20px) / 2);
    height: auto;
    aspect-ratio: 1 / 1;
    top: calc(50% + 10px);
  }

  .hero-images {
    width: 100%;
    height: auto;

    aspect-ratio: 1 / 1;

    margin: 0%;
  }

  .courses-slider,
  .courses-nav {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    height: 0;
  }

  .section {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .section-title {
    font-family: "Involve";
    font-weight: 600;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: 0%;

    margin-bottom: 24px !important;
  }

  .advantage-card {
    padding: 24px;
  }

  .advantage-icon {
    width: 64px;
    height: 64px;
  }

  .main-nav {
    display: none;
  }

  .mobile-nav-toggle {
    display: block;
  }

  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .hero-title {
    font-weight: 600;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: 0%;

    text-align: left;
  }

  .hero-subtitle {
    margin: 0 0 24px;

    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
    letter-spacing: 0%;

    text-align: left;
  }

  .advantages-grid {
    grid-template-columns: 1fr 1fr;
  }

  .advantage-title {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: 0%;
  }

  .course-category {
    grid-template-columns: 1fr;
    background-color: transparent;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  #courses .ProfBlock {
    background-color: transparent;
    overflow: hidden;
  }

  #courses .ProfBlock > summary,
  #courses .ProfBlock .course-content {
    background-color: #f8f8f8;
  }

  #courses .ProfBlock .course-content {
    padding-bottom: 120px;
  }

  .course-image-container {
    top: -30px;
  }

  .job-cards-wrapper {
    flex-direction: column;
    align-items: center;
  }

  .how-it-works-container {
    grid-template-columns: 1fr;
  }

  .how-it-works-image {
    order: -1;
    text-align: center;
  }

  .footer-top,
  .footer-bottom,
  .footer-contacts {
    flex-direction: column;
    gap: 40px;
  }

  .footer-logo-and-socials {
    align-items: center;
  }

  .footer-bottom {
    align-items: center;
    text-align: center;
  }

  .footer-links {
    justify-content: center;
    max-width: 100%;
  }

  .ProfList {
    min-width: 0%;
    width: 100%;
    max-width: 100%;
  }

  .hero-section {
    margin-bottom: 40px;
    background-color: white;
  }

  .section {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .header-actions .btn-small,
  .header-actions .lang-switcher {
    display: none;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .why-1c-grid {
    grid-template-columns: 1fr;
  }

  .hero-content {
    width: 100%;
    max-width: 100%;
  }

  .hero-content .btn {
    width: 100%;
    max-width: 100%;
  }

  .hero-images {
    margin: 0% auto;
  }

  .jobs-bg-container {
    background-color: #1a1a1a;
    background: #1a1a1a;
  }
  .jobs-subtitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0%;
  }

  .job-card {
    border-radius: 16px;
    background: #f8f8f8;
    width: 100%;
    height: fit-content;
  }

  .job-card h4 {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: 0%;
  }
  .job-card p {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: 0%;
  }

  .how-it-works-container {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
  }

  .steps {
    flex-direction: column;
    justify-content: flex-start;
  }
  .steps > .step {
    width: 100%;
  }

  .step-text h4 {
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0%;
    line-height: 130%;
  }

  .how-it-works-note {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: 0%;
  }
  .ProfText {
    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
    letter-spacing: 0%;
  }

  .course-content {
    width: 100%;
  }
  .course-category {
    flex-direction: column;
    justify-content: flex-start;
    height: auto;
  }

  .course-image-container {
    width: 100%;
  }

  .IMG {
    width: 100%;
    height: auto;
    border-radius: 16px;
    aspect-ratio: 0.7715 / 1;
  }

  .course-image-overlay {
    top: 0px;
    width: fit-content;
    height: fit-content;
    transform: translateX(-50%) translateY(-50%);
  }

  .hero-bg-img {
    width: 100%;
    margin: 0%;

    background: url("./../assets/img/ReDesign/pages/new_land/bg_mobile.png");
    background-repeat: no-repeat;
    background-position: 50% 100%;
    background-size: cover;

    filter: none;
  }
}

@media (max-width: 480px) {
}

@media (min-width: 992px) {
  .courses-mobile {
    height: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  .Navbar {
    position: absolute;
    padding: 15px 0%;
    top: 0;

    background-color: #f9d773 !important;
  }
}

@media (max-width: 480px) {
}
@media (min-width: 480px) and (max-width: 992px) {
}
@media (min-width: 992px) and (max-width: 1280px) {
  .container {
    width: 100%;
    max-width: 992px;
  }

  .jobs-bg-container {
    background-size: cover;
    border-radius: 24px;
    padding: 40px 0;
    margin: 0 auto;
    max-width: 100%;
  }
}
@media (min-width: 1400px) and (max-width: 1600px) {
}
@media (min-width: 1600px) {
}
</style>
